module.exports = __webpack_public_path__ + "img/2024-09-19c_1.141abc5a.jpg";